/**
 * Blocks component
 * 
 */

import React, { PureComponent } from 'react';

// Functions

import Helpers from '../../utils/functions/helpers';

export default class Blocks extends PureComponent {

	render() {

		const { items } = this.props;
		
		if (Helpers.isEmpty(items) === false) {

			return (

				<div className="row">
					{
						items.map((item, i) => {

							return (

								<div key={'col-' + i} className="col-xs-12 col-md-6">
									
									{ !! item.title && <h2 className="h3">{item.title}</h2> }
									{ !! item.text && <p>{item.text}</p> }

								</div>
							)

						})
					}
				</div>
			)
		}
		else {

			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/blocks.js